"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const Breadcrumbs = ({ links }) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: links.map((link, idx) => ((0, jsx_runtime_1.jsx)(typography_1.H4, { children: link }, "link" + idx))) }, void 0));
};
exports.Breadcrumbs = Breadcrumbs;
const Wrapper = styled_components_1.default.div `
  & a:visited,
  & a:link,
  & a:active {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  & > h4 {
    display: inline-block;
    font-size: 1.125rem;

    & > * {
      cursor: pointer;
      font-weight: 400;
      line-height: 1.5rem;
      margin-bottom: 0;
      text-decoration: underline;
      text-transform: capitalize;
    }
  }

  h4:last-of-type > * {
    font-weight: 600;
    text-decoration: none;
  }

  & > h4:not(:last-of-type) {
    font-weight: 400;
  }

  h4:not(:last-of-type)::after {
    content: "\\a0/\\a0";
    display: inline-block;
  }
`;
//# sourceMappingURL=index.js.map